// This file can be replaced during build by using the `fileReplacements` array (angular.json),
// same pattern as `src/brands/brand.ts`. The `ls` brand replaces it with `src/app/auth/ls/auth-strategy.ts`.
import { HttpRequest } from '@angular/common/http';
import { IAuthStrategy } from './iauth-strategy';

class DefaultAuthStrategy implements IAuthStrategy {
  applyAuth(req: HttpRequest<any>): HttpRequest<any> {
    const initialToken = sessionStorage.getItem('initialToken');
    if (initialToken) {
      sessionStorage.removeItem('initialToken');
      return req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + initialToken)
      });
    }

    const jwt = sessionStorage.getItem('userToken');
    if (jwt) {
      return req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + jwt)
      });
    }

    return req;
  }

  requiresLoginFlow(): boolean {
    return true;
  }
}

export const AuthStrategy: IAuthStrategy = new DefaultAuthStrategy();
